import { Component, Prop, h, Host } from '@stencil/core';

const COMPONENT_NAME = 'ul-how-it-works-type-1';

/**
 * "How it works" section for USLegal form pages. Displays a section heading
 * and step cards arranged horizontally on desktop and stacked on mobile.
 * Each card shows an illustration, a bold step title, and a short description.
 *
 * @product uslegal
 * @source hiw
 * @version 1.0.0
 * @category USLegal
 * @contentConfig How it works section with step cards for USLegal form pages
 * @slot heading - {optional}, <me-heading tag=["h1", "h2", "h3", "h4", "h5", "h6", "div"]> - Section heading (inline editable)
 * @slot items - {required}, {multiple}, {min-items: 1}, {max-items: 4}, <li class="ul-how-it-works-type-1__item"> - Step items with images and text
 * @example
 *   <ul-how-it-works-type-1>
 *     <me-heading slot="heading" variant="4" tag="h2">How it works</me-heading>
 *     <li slot="items" class="ul-how-it-works-type-1__item">
 *       <div class="ul-how-it-works-type-1__image-wrapper">
 *         <img src="https://marketing-static.signnow.com/366/images/forms/bitmap/open-form-icon@2x.png" alt="" class="ul-how-it-works-type-1__image" loading="lazy" width="80" height="80" />
 *       </div>
 *       <div class="ul-how-it-works-type-1__content">
 *         <h3 class="ul-how-it-works-type-1__title">Open form</h3>
 *         <span class="ul-how-it-works-type-1__description">Find your state-specific form</span>
 *       </div>
 *     </li>
 *   </ul-how-it-works-type-1>
 */
@Component({
  tag: 'ul-how-it-works-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class ULHowItWorksType1 {
  @Prop() colorMode: 'uslegal' | 'inverted' = 'uslegal';

  render() {
    return (
      <Host data-color-mode={this.colorMode}>
        <section class={COMPONENT_NAME}>
          <div class={`${COMPONENT_NAME}__container`}>
            <slot name="heading"></slot>
            <ul class={`${COMPONENT_NAME}__list`}>
              <slot name="items"></slot>
            </ul>
          </div>
        </section>
      </Host>
    );
  }
}
